export const CAMPAIGN_STATUS_OPTIONS = [
  { value: 'All', label: 'All' },
  { value: 'PENDING', label: 'Pending' },
  { value: 'APPROVED', label: 'Approved' },
  { value: 'EXPIRED', label: 'Expired' },
  { value: 'PUBLISHED', label: 'Published' },
  { value: 'REJECTED', label: 'Rejected' },
  { value: 'PARTIAL_CANCEL', label: 'Partial Cancel' },
  { value: 'CANCEL', label: 'Cancelled' },
  { value: 'CANCELLED', label: 'Cancelled' },
  { value: 'ESCALATED_TO_LCM', label: 'Escalated • LCM' },
  { value: 'ESCALATED_TO_ADMIN', label: 'Escalated • Admin' },
  { value: 'FORWARDED_TO_CCV', label: 'Forwarded • CCV' },
  { value: 'LIVE', label: 'Live' },
  { value: 'DRAFT', label: 'Draft' },
] as const;

export const STATUS_COLORS: Record<
  string,
  { bg: string; text: string; dotBg: string }
> = {
  All: {
    bg: 'bg-[#F3F4F6]',
    text: 'text-[#374151]',
    dotBg: 'bg-[#9CA3AF]',
  },
  APPROVED: {
    bg: 'bg-[#DDF5EA]',
    text: 'text-[#12785A]',
    dotBg: 'bg-[#12785A]',
  },
  PENDING: {
    bg: 'bg-[#FFF3DC]',
    text: 'text-[#A15C00]',
    dotBg: 'bg-[#A15C00]',
  },
  REJECTED: {
    bg: 'bg-[#FFF5F6]',
    text: 'text-[#B4233A]',
    dotBg: 'bg-[#B4233A]',
  },
  PUBLISHED: {
    bg: 'bg-[#DFE9FA]',
    text: 'text-[#2B3E8A]',
    dotBg: 'bg-[#2B3E8A]',
  },
  CANCELLED: {
    bg: 'bg-[#FFF5F6]',
    text: 'text-[#B4233A]',
    dotBg: 'bg-[#B4233A]',
  },
  CANCEL: {
    bg: 'bg-[#FFF5F6]',
    text: 'text-[#B4233A]',
    dotBg: 'bg-[#B4233A]',
  },
  EXPIRED: {
    bg: 'bg-[#FFF3DC]',
    text: 'text-[#A15C00]',
    dotBg: 'bg-[#A15C00]',
  },
  LIVE: {
    bg: 'bg-[#DFE9FA]',
    text: 'text-[#2B3E8A]',
    dotBg: 'bg-[#2B3E8A]',
  },
  PARTIAL_CANCEL: {
    bg: 'bg-[#EDE4F8]',
    text: 'text-[#5B3A9E]',
    dotBg: 'bg-[#5B3A9E]',
  },
  DRAFT: {
    bg: 'bg-[#F3F2F9]',
    text: 'text-[#6A6688]',
    dotBg: 'bg-[#6A6688]',
  },
  ESCALATED_TO_LCM: {
    bg: 'bg-[#FDF4FF]',
    text: 'text-[#9333EA]',
    dotBg: 'bg-[#A855F7]',
  },
  ESCALATED_TO_ADMIN: {
    bg: 'bg-[#FEE2E2]',
    text: 'text-[#DC2626]',
    dotBg: 'bg-[#EF4444]',
  },
  FORWARDED_TO_CCV: {
    bg: 'bg-[#EFF6FF]',
    text: 'text-[#2563EB]',
    dotBg: 'bg-[#3B82F6]',
  },
};

export function getCampaignStatusColor(status?: string) {
  return STATUS_COLORS[status || ''] || STATUS_COLORS.DRAFT;
}

export function formatCampaignDate(value?: string | Date | null) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function formatCampaignDuration(
  campaign: {
    customDuration?: string | number | null;
    duration?: string | number | null;
    adDuration?: string | number | null;
    analytics?: {
      customDuration?: string | number | null;
    } | null;
    bookedSlots?: Array<{ duration?: string | number | null }> | null;
  },
) {
  const slotDuration = campaign.bookedSlots?.find(
    (s) => s?.duration != null && s.duration !== '',
  )?.duration;
  const raw =
    campaign.customDuration ??
    campaign.analytics?.customDuration ??
    campaign.duration ??
    campaign.adDuration ??
    slotDuration;
  if (raw == null || raw === '') return '—';
  const n = Number(raw);
  if (!Number.isNaN(n) && n > 0) return `${n}s`;
  return String(raw);
}
